<ng-container [ngSwitch]="navLinkMode()">
  <a
    *ngSwitchCase="'internalURL'"
    class="dropdown-item"
    [routerLink]="navLink.route"
    tabindex="0">
    <div class="dropdown-item-content" tabindex="-1">
      <img class="dropdown-icon" [src]="navLink.iconUrl" />
      <span class="dropdown-link-text">{{
        navLink.translationKey | translate
      }}</span>
    </div>
  </a>

  <a
    *ngSwitchCase="'externalURL'"
    class="dropdown-item"
    [href]="navLink.route"
    tabindex="0">
    <div class="dropdown-item-content" tabindex="-1">
      <img class="dropdown-icon" [src]="navLink.iconUrl" />
      <span class="dropdown-link-text">{{
        navLink.translationKey | translate
      }}</span>
    </div>
  </a>

  <button
    *ngSwitchCase="'callback'"
    class="dropdown-item logout"
    role="button"
    (click)="navLinkClicked()"
    tabindex="0">
    <div class="dropdown-item-content" tabindex="-1">
      <img class="dropdown-icon" [src]="navLink.iconUrl" />
      <span class="dropdown-link-text">{{
        navLink.translationKey | translate
      }}</span>
    </div>
  </button>
</ng-container>
